var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import LazyLoad from 'react-lazyload';
import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkSpacing } from 'uitk-react-spacing';
import { equals } from '../../../../../../helpers/common-helper';
import { TripSaveItemWrapper } from '../../../../../common/trip-save-item-wrapper';
import { CardLink, ImageBadges, PlaceholderCards } from '../..';
import { ActivityCardContentBottom } from './activity-card-content-bottom';
import { ActivityCardContentTop } from './activity-card-content-top';
import { ActivityCardImageCarousel } from './activity-card-image-carousel';
var ActivityTileCardComponent = function (props) {
  var _a, _b, _c, _d;
  var activity = props.activity,
    loading = props.loading,
    tag = props.tag,
    onClick = props.onClick,
    activityGroup = props.activityGroup,
    className = props.className,
    tabIndex = props.tabIndex,
    ariaHidden = props.ariaHidden;
  var accessibilityStyleAndProperties = {
    className: className,
    tabIndex: tabIndex,
    'aria-hidden': ariaHidden
  };
  var cardBadges = activity === null || activity === void 0 ? void 0 : activity.cardBadges;
  var imageCarousel = activity.imageCarousel;
  var defaultHeartLayoutPosition = {
    type: 'absolute',
    position: {
      top: 'zero',
      right: 'zero',
      zindex: 'layer3'
    }
  };
  if (loading) {
    return React.createElement(PlaceholderCards, null);
  }
  var renderImage = function (image, key) {
    return React.createElement(UitkImage, {
      alt: image === null || image === void 0 ? void 0 : image.description,
      src: image === null || image === void 0 ? void 0 : image.url,
      key: key
    });
  };
  return React.createElement(React.Fragment, null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkCard, __assign({
    "data-testid": "activity-tile-card",
    tag: tag
  }, accessibilityStyleAndProperties, {
    border: true
  }), activity.saveItem && React.createElement(TripSaveItemWrapper, {
    saveItem: activity.saveItem,
    heartLayoutPosition: defaultHeartLayoutPosition
  }), React.createElement(UitkLayoutFlex, {
    justifyContent: "space-between",
    direction: "column",
    className: "max-height"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement("section", null, React.createElement(IntersectionTracker, {
    referrerId: "".concat((_a = activity.clientSideAnalytics) === null || _a === void 0 ? void 0 : _a.referrerId, ".activity-card.view.impression"),
    linkName: ((_b = activity.clientSideAnalytics) === null || _b === void 0 ? void 0 : _b.linkName) || 'Activities card view impression',
    trackOnce: true,
    intersectionOptions: {
      threshold: 1.0
    }
  }, React.createElement(UitkLayoutPosition, {
    type: "relative"
  }, !imageCarousel && React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, React.createElement("div", {
    "data-testid": "activity-tile-card-img"
  }, React.createElement(LazyLoad, {
    height: "100%",
    offset: [100, 100],
    once: true
  }, renderImage(activity === null || activity === void 0 ? void 0 : activity.image)))), imageCarousel && React.createElement(ActivityCardImageCarousel, {
    carousel: imageCarousel,
    imageAspectRatio: UitkFigureAspectRatioType.R1_1
  }), cardBadges && React.createElement(ImageBadges, {
    badges: cardBadges,
    isVerticalLayout: true
  })), React.createElement(UitkCardContentSection, null, React.createElement(ActivityCardContentTop, {
    activity: activity,
    activityGroup: activityGroup
  }))))), React.createElement(UitkLayoutFlexItem, null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkCardContentSection, {
    className: "uitk-card-text-segment"
  }, React.createElement(ActivityCardContentBottom, {
    activity: activity,
    activityGroup: activityGroup
  }))), React.createElement(ViewMedium, null, React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'three'
    }
  }, React.createElement(UitkCardContentSection, null, React.createElement(ActivityCardContentBottom, {
    activity: activity,
    activityGroup: activityGroup
  }))))))), activity && React.createElement(CardLink, {
    activity: activity,
    onClick: onClick
  }))), React.createElement(ViewLarge, null, React.createElement(UitkCard, __assign({
    "data-testid": "activity-tile-card",
    tag: tag
  }, accessibilityStyleAndProperties, {
    className: accessibilityStyleAndProperties.className,
    border: true
  }), activity.saveItem && React.createElement(TripSaveItemWrapper, {
    saveItem: activity.saveItem,
    heartLayoutPosition: defaultHeartLayoutPosition
  }), React.createElement(UitkLayoutFlex, {
    justifyContent: "space-between",
    direction: "column",
    className: "max-height"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement("section", null, React.createElement(IntersectionTracker, {
    referrerId: "".concat((_c = activity.clientSideAnalytics) === null || _c === void 0 ? void 0 : _c.referrerId, ".activity-card.view.impression"),
    linkName: ((_d = activity.clientSideAnalytics) === null || _d === void 0 ? void 0 : _d.linkName) || 'Activities card view impression',
    trackOnce: true,
    intersectionOptions: {
      threshold: 1.0
    }
  }, React.createElement(UitkLayoutPosition, {
    type: "relative"
  }, !imageCarousel && React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, React.createElement("div", {
    "data-testid": "activity-tile-card-img"
  }, React.createElement(LazyLoad, {
    height: "100%",
    offset: [100, 100],
    once: true
  }, React.createElement(React.Fragment, null, renderImage(activity === null || activity === void 0 ? void 0 : activity.image))))), imageCarousel && React.createElement(ActivityCardImageCarousel, {
    carousel: imageCarousel
  }), cardBadges && React.createElement(ImageBadges, {
    badges: cardBadges,
    isVerticalLayout: true
  })), React.createElement(UitkSpacing, {
    padding: {
      inline: 'three',
      blockstart: 'three',
      blockend: 'four'
    }
  }, React.createElement(UitkCardContentSection, {
    padded: false
  }, React.createElement(ActivityCardContentTop, {
    activity: activity,
    activityGroup: activityGroup
  })))))), React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkSpacing, {
    padding: {
      inline: 'three',
      blockend: 'three'
    }
  }, React.createElement(UitkCardContentSection, {
    padded: false
  }, React.createElement(ActivityCardContentBottom, {
    activity: activity,
    activityGroup: activityGroup
  }))))), activity && React.createElement(CardLink, {
    activity: activity,
    onClick: onClick
  })))));
};
export var ActivityTileCard = React.memo(ActivityTileCardComponent, function (prevProps, nextProps) {
  var isActivitySame = Boolean(prevProps.activity) && Boolean(nextProps.activity);
  isActivitySame = isActivitySame || prevProps.activity && nextProps.activity && equals(prevProps.activity.id, nextProps.activity.id);
  return !isActivitySame;
});